"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryFireHazardSafetyZoneLRA = exports.queryFireHazardSafetyZoneSRA = void 0;
const core_1 = require("@natomas-org/core");
const index_1 = require("../index");
const queryFireHazardSafetyZoneSRA = async (request) => {
    return (0, index_1.queryPublicArcGIS)(core_1.SRA_GIS_LAYER_URL, request, "SRA,HAZ_CLASS", false).then((response) => {
        var _a, _b;
        const responseArray = (_b = (_a = response === null || response === void 0 ? void 0 : response.features) === null || _a === void 0 ? void 0 : _a.map((feature) => feature === null || feature === void 0 ? void 0 : feature.properties)) !== null && _b !== void 0 ? _b : null;
        let responseToReturn = null;
        if (responseArray &&
            responseArray.length > 0 &&
            responseArray[0]["SRA"] === "SRA") {
            responseToReturn = responseArray[0]["HAZ_CLASS"];
        }
        return responseToReturn;
    });
};
exports.queryFireHazardSafetyZoneSRA = queryFireHazardSafetyZoneSRA;
const queryFireHazardSafetyZoneLRA = async (request) => {
    return (0, index_1.queryPublicArcGIS)(core_1.LRA_GIS_LAYER_URL, request, "SRA", true).then((response) => {
        var _a, _b;
        const responseArray = (_b = (_a = response === null || response === void 0 ? void 0 : response.features) === null || _a === void 0 ? void 0 : _a.map((feature) => feature === null || feature === void 0 ? void 0 : feature.properties)) !== null && _b !== void 0 ? _b : null;
        let responseToReturn = null;
        if (responseArray &&
            responseArray.length > 0 &&
            responseArray[0]["SRA"] === "LRA") {
            responseToReturn = "Very High";
        }
        return responseToReturn;
    });
};
exports.queryFireHazardSafetyZoneLRA = queryFireHazardSafetyZoneLRA;
//# sourceMappingURL=fireZones.js.map